import activitiesWithEarlyFinishTime from 'styles/assets/svg/widgets/activitiesWithEarlyFinishTime.svg';
import activitiesWithLateStartTime from 'styles/assets/svg/widgets/activitiesWithLateStartTime.svg';
import activityPredecessors from 'styles/assets/svg/widgets/activityPredecessors.svg';
import allScheduleQualityChecks from 'styles/assets/svg/widgets/allScheduleQualityChecks.svg';
import baselineExecutionIndex from 'styles/assets/svg/widgets/baselineExecutionIndex.svg';
import battlecardsRowsBoard from 'styles/assets/svg/widgets/battlecardsRowsBoard.svg';
import changeSummary from 'styles/assets/svg/widgets/changeSummary.svg';
import constraintsWithoutRelationship from 'styles/assets/svg/widgets/constraintsWithoutRelationship.svg';
import criticalPathAdded from 'styles/assets/svg/widgets/criticalPathAdded.svg';
import criticalPathCongestion from 'styles/assets/svg/widgets/criticalPathCongestion.svg';
import criticalPathLengthIndex from 'styles/assets/svg/widgets/criticalPathLengthIndex.svg';
import criticalPathRemoved from 'styles/assets/svg/widgets/criticalPathRemoved.svg';
import criticalPathTest from 'styles/assets/svg/widgets/criticalPathTest.svg';
import criticalityWeightedSCurve from 'styles/assets/svg/widgets/criticalityWeightedSCurve.svg';
import currentSpi from 'styles/assets/svg/widgets/currentSpi.svg';
import customReportText from 'styles/assets/svg/widgets/customReportText.svg';
import danglingLogic from 'styles/assets/svg/widgets/danglingLogic.svg';
import duplicateRelations from 'styles/assets/svg/widgets/duplicateRelations.svg';
import finishDateOverallSummary from 'styles/assets/svg/widgets/finishDateOverallSummary.svg';
import frequentlyUsedResources from 'styles/assets/svg/widgets/frequentlyUsedResources.svg';
import ganttChart from 'styles/assets/svg/widgets/ganttChart.svg';
import hardConstraints from 'styles/assets/svg/widgets/hardConstraints.svg';
import highFloatByActivityType from 'styles/assets/svg/widgets/highFloatByActivityType.svg';
import highLevelProgramLatest from 'styles/assets/svg/widgets/highLevelProgramLatest.svg';
import image from 'styles/assets/svg/widgets/image.svg';
import incompleteWithFinishDate from 'styles/assets/svg/widgets/incompleteWithFinishDate.svg';
import invalidActualDates from 'styles/assets/svg/widgets/invalidActualDates.svg';
import invalidForecastDates from 'styles/assets/svg/widgets/invalidForecastDates.svg';
import keyAchievements from 'styles/assets/svg/widgets/keyAchievements.svg';
import keyActivities from 'styles/assets/svg/widgets/keyActivities.svg';
import lags from 'styles/assets/svg/widgets/lags.svg';
import largestAddedActivities from 'styles/assets/svg/widgets/largestAddedActivities.svg';
import largestDeletedActivities from 'styles/assets/svg/widgets/largestDeletedActivities.svg';
import largestDurationVariance from 'styles/assets/svg/widgets/largestDurationVariance.svg';
import largestFloatChanges from 'styles/assets/svg/widgets/largestFloatChanges.svg';
import leads from 'styles/assets/svg/widgets/leads.svg';
import longDuration from 'styles/assets/svg/widgets/longDuration.svg';
import missedActivities from 'styles/assets/svg/widgets/missedActivities.svg';
import missingBaselineDates from 'styles/assets/svg/widgets/missingBaselineDates.svg';
import negativeFloatByActivityType from 'styles/assets/svg/widgets/negativeFloatByActivityType.svg';
import outOfSequence from 'styles/assets/svg/widgets/outOfSequence.svg';
import phasePerformanceChart from 'styles/assets/svg/widgets/phasePerformanceChart.svg';
import prioritiesMatrix from 'styles/assets/svg/widgets/prioritiesMatrix.svg';
import productivityRate from 'styles/assets/svg/widgets/productivityRate.svg';
import productivityRiskKpi from 'styles/assets/svg/widgets/productivityRiskKpi.svg';
import productivityRiskTrend from 'styles/assets/svg/widgets/productivityRiskTrend.svg';
import progressSummary from 'styles/assets/svg/widgets/progressSummary.svg';
import activitiesPivotTableView from 'styles/assets/svg/widgets/projectActivitiesPivotView.svg';
import projectScorecards from 'styles/assets/svg/widgets/projectScorecards.svg';
import projectSummary from 'styles/assets/svg/widgets/projectSummary.svg';
import rarelyUsedResources from 'styles/assets/svg/widgets/rarelyUsedResources.svg';
import relationshipTypes from 'styles/assets/svg/widgets/relationshipTypes.svg';
import relationshipsActivitiesRatio from 'styles/assets/svg/widgets/relationshipsActivitiesRatio.svg';
import reportSummary from 'styles/assets/svg/widgets/reportSummary.svg';
import resourcesAnalysisChart from 'styles/assets/svg/widgets/resourcesAnalysisChart.svg';
import riskHeatMap from 'styles/assets/svg/widgets/riskHeatMap.svg';
import scheduleDelay from 'styles/assets/svg/widgets/scheduleDelay.svg';
import scheduleQualityScore from 'styles/assets/svg/widgets/scheduleQualityScore.svg';
import scheduleQualityTrend from 'styles/assets/svg/widgets/scheduleQualityTrend.svg';
import sensitiveActivitiesByDuration from 'styles/assets/svg/widgets/sensitiveActivitiesByDuration.svg';
import sharedResourcesAvailability from 'styles/assets/svg/widgets/sharedResourcesAvailability.svg';
import softConstraints from 'styles/assets/svg/widgets/softConstraints.svg';
import spiTrend from 'styles/assets/svg/widgets/spiTrend.svg';
import startFinishTimeNotRound from 'styles/assets/svg/widgets/startFinishTimeNotRound.svg';
import timelineAndDensity from 'styles/assets/svg/widgets/timelineAndDensity.svg';
import topCriticalActivitiesDelayDrivers from 'styles/assets/svg/widgets/topCriticalActivitiesDelayDrivers.svg';
import topDurationOverrunRisk from 'styles/assets/svg/widgets/topDurationOverrunRisk.svg';
import topFinishDateChanges from 'styles/assets/svg/widgets/topFinishDateChanges.svg';
import topOverdueOverrunActivities from 'styles/assets/svg/widgets/topOverdueOverrunActivities.svg';
import topRelationshipsCountChanges from 'styles/assets/svg/widgets/topRelationshipsCountChanges.svg';
import topRelationshipsTypeChanges from 'styles/assets/svg/widgets/topRelationshipsTypeChanges.svg';
import topStartDateChanges from 'styles/assets/svg/widgets/topStartDateChanges.svg';
import topStatusChanges from 'styles/assets/svg/widgets/topStatusChanges.svg';
import trends from 'styles/assets/svg/widgets/trends.svg';
import unresourcedActivities from 'styles/assets/svg/widgets/unresourcedActivities.svg';
import workSettingsApplied from 'styles/assets/svg/widgets/workSettingsApplied.svg';

export const WIDGET_SVG_MAP: Record<string, string> = {
    activitiesWithEarlyFinishTime,
    activitiesWithLateStartTime,
    activityPredecessors,
    workSettingsApplied,
    allScheduleQualityChecks,
    baselineExecutionIndex,
    battlecardsRowsBoard,
    changeSummary,
    constraintsWithoutRelationship,
    activitiesPivotTableView,
    criticalPathAdded,
    criticalPathCongestion,
    criticalPathLengthIndex,
    criticalPathRemoved,
    criticalPathTest,
    criticalityWeightedSCurve,
    currentSpi,
    customReportText,
    danglingLogic,
    duplicateRelations,
    finishDateOverallSummary,
    frequentlyUsedResources,
    ganttChart,
    hardConstraints,
    highFloatByActivityType,
    highLevelProgramLatest,
    incompleteWithFinishDate,
    invalidActualDates,
    invalidForecastDates,
    keyAchievements,
    keyActivities,
    lags,
    largestAddedActivities,
    largestDeletedActivities,
    largestDurationVariance,
    largestFloatChanges,
    leads,
    longDuration,
    missedActivities,
    missingBaselineDates,
    negativeFloatByActivityType,
    outOfSequence,
    phasePerformanceChart,
    prioritiesMatrix,
    productivityRate,
    productivityRiskKpi,
    productivityRiskTrend,
    progressSummary,
    projectScorecards,
    projectSummary,
    rarelyUsedResources,
    relationshipTypes,
    relationshipsActivitiesRatio,
    reportSummary,
    resourcesAnalysisChart,
    riskHeatMap,
    scheduleDelay,
    scheduleQualityScore,
    scheduleQualityTrend,
    sensitiveActivitiesByDuration,
    sharedResourcesAvailability,
    softConstraints,
    spiTrend,
    startFinishTimeNotRound,
    timelineAndDensity,
    topCriticalActivitiesDelayDrivers,
    topDurationOverrunRisk,
    topFinishDateChanges,
    topOverdueOverrunActivities,
    topRelationshipsCountChanges,
    topRelationshipsTypeChanges,
    topStartDateChanges,
    topStatusChanges,
    trends,
    unresourcedActivities,
    workSettingsApplied,
    image
};
